import React, {useEffect, useState} from 'react'
import SelectWeekDays from "../../../../components/select/SelectWeekDays";
import {Col, FormGroup, Label, Row} from "reactstrap";
import RecurringDay from "../components/RecurringDay";
import {useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";


const days = require('../../../../data/weekdays.json')

const RecurringPromotion = ({udn, onChangeData, path}) => {
    const componentState = useSelector(state => getStateByPath(state, path));
    const { domainObject } = componentState?.data;



    const [selectedDays, setSelectedDays] = useState(domainObject?.schedules || []);
    const [formedData, setFormedData] = useState(domainObject?.schedules || []);










    // Dar formato a los dias que ya tiene la promoción y que se mostrarán por default en el selector
    useEffect(() => {
        if(!domainObject?.schedules || domainObject?.schedules.length === 0) return;

        const formedSelectedDays = domainObject.schedules.map( sch => {
            const day = days.find( d => d?.id === sch?.dayOfWeek);
            return {
                ...day,
                hourStart: sch?.hourStart,
                hourEnd: sch?.hourEnd,
            }
        });

        setSelectedDays(formedSelectedDays);
    }, [domainObject] );





    const onChangeSelectedDays = days => {
         const removedDays = selectedDays.filter(sd => !days.some(d => d.id === sd.id));
         const addedDays = days.filter(d => !selectedDays.some(sd => sd.id === d.id));

        if(removedDays.length > 0)
            removedDays.forEach( rd => onRemoveDay(rd.id) );

        if(addedDays.length > 0)
            addedDays.forEach( ad => onAddDay(ad.id) );
    }






    const onScheduleChange = (dayOfWeek, hourStart, hourEnd, hasError) => {

        const newFormedDate ={
            dayOfWeek,
            hourStart,
            hourEnd,
            hasError
        }


        let updatedFormedData = []


        const existingIndex = formedData.findIndex(fd => fd.dayOfWeek === dayOfWeek);
        if (existingIndex !== -1) {
            // Si ya existe, actualiza el objeto existente
            updatedFormedData = [...formedData];
            updatedFormedData[existingIndex] = newFormedDate;
            setFormedData(updatedFormedData);
        } else {
            // Si no existe, agrega el nuevo objeto
            updatedFormedData = [...formedData, newFormedDate];
            setFormedData(updatedFormedData);
        }

        onChangeData('SCHEDULE', updatedFormedData);
    }





    const onAddDay = dayOfWeek => {
        if(selectedDays.some(sd => sd.id === dayOfWeek)) return;

        const day = days.find(d => d.id === dayOfWeek);
        if(!day) return;

        const newDays = [...selectedDays, {...day, hourStart: '00:00', hourEnd: '00:00', hasError: true, errorType: 'NO_HOURS', errorMessage: 'No se han definido las horas para este día'}];
        setSelectedDays(newDays);

        const newFormedData = [...formedData, {dayOfWeek, hourStart: '00:00', hourEnd: '00:00', hasError: true}];

        onChangeData('SCHEDULE', newFormedData);
    }





    const onRemoveDay = dayOfWeek => {
        const newDays = selectedDays.filter(sd => sd.id !== dayOfWeek)
        setSelectedDays(newDays);

        const dataFiltered = formedData.filter(fd => fd.dayOfWeek !== dayOfWeek); // También eliminar del formedData

        setFormedData(dataFiltered);

        onChangeData('SCHEDULE', dataFiltered);
    }







    return <>
        <Row>
            <Col md={12} className={'mb-3'}>
                <FormGroup>
                <Label for="startDate">Selecciona los días en los que aplicará la promoción</Label>
                  <SelectWeekDays
                      initialValues={selectedDays}
                      onChange={onChangeSelectedDays}
                  />
                </FormGroup>
            </Col>
        </Row>
        {
            selectedDays.length > 0 && selectedDays
                .sort( (a,b) => a.value - b.value)
                .map( day => {

                    const schedule = domainObject?.schedules?.find( sch => sch?.dayOfWeek === day?.id)


                    return <RecurringDay
                        key={day?.id}
                        udn={udn}
                        day={day}
                        onChange={onScheduleChange}
                        onRemoveDay={onRemoveDay}
                        { ...schedule }
                    />
                })
        }
    </>
}

export default RecurringPromotion